import { useEffect } from "react";
import { Modal, Select } from "antd";
import LicenseIcon from "../../../assets/images/vectors/SideBarIcons/LicenseIcon";
import usePost from "../../../global/hooks/usePost";
import usePut from "../../../global/hooks/usePut";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import { PurchaseLicenseCodeSelector } from "../../MySite/Components/PurchaseLicenseCodeSelector";
import useGet from "../../../global/hooks/useGet";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import { codetypeOptions } from "../../../utils/Common";
import { InfoChip } from "../../../global/components/InfoChip";

const LicenseItemModal = ({
  open,
  setOpen,
  licenseId,
  editingItem,
  existingItems,
  setEditingItem,
  itemsRefetch,
  oemNo,
  isOemLicense,
}) => {
  const isEdit = editingItem?.ItemNo != null;

  const itemsUrl = `${process.env.REACT_APP_API_URL}/api/licenses/${licenseId}/items/`;
  const { error: postError, postData } = usePost(itemsUrl);
  const { error: putError, putData } = usePut(itemsUrl);

  useEffect(() => {
    const error = postError || putError;
    if (error) {
      openErrorNotification(
        error?.response?.data?.message || "Something went wrong",
      );
    }
  }, [postError, putError]);

  const handleClose = () => setOpen(false);
  const { data: oemOptionsData } = useGet(
    open && isOemLicense
      ? `${process.env.REACT_APP_API_URL}/api/dealers/options/`
      : null,
  );
  const oemOptions = getModifiedResponse(oemOptionsData, "oems");
  const oemLabel = oemOptions?.find(
    (o) => Number(o.value) === Number(oemNo),
  )?.label;
  const codeTypeLabel = codetypeOptions?.find((o) => o.value === 0)?.label;
  const effectiveOemNo = isOemLicense ? oemNo : null;
  const onPick = async (code) => {
    if (isEdit && Number(code.CodeNo) === Number(editingItem.CodeNo)) {
      return true;
    }
    const payload = { CodeNo: Number(code.CodeNo) };
    const result = isEdit
      ? await putData(payload, `${itemsUrl}${editingItem.ItemNo}/`)
      : await postData(payload);
    if (result == null) return false;
    openConfirmNotification("Success");
    itemsRefetch?.();
    return true;
  };

  return (
    <Modal
      open={open}
      closable={false}
      onCancel={handleClose}
      afterClose={() => setEditingItem(null)}
      footer={null}
      width={1000}
      centered
      destroyOnClose
      title={
        <div className="flex items-center justify-between gap-3 bg-gray-200 p-2 rounded-md">
          <div className="flex items-center">
            <LicenseIcon className="text-[18px] text-black " />
            <span className="text-[14px] font-['Poppins'] text-black ml-2">
              {isEdit ? "Edit license item" : "Add license item"}
            </span>
          </div>
          <div className="flex items-center gap-2 font-normal">
            {isOemLicense ? (
              oemNo && oemLabel ? (
                <InfoChip>{oemLabel}</InfoChip>
              ) : null
            ) : (
              <InfoChip>Generic</InfoChip>
            )}
            {codeTypeLabel ? <InfoChip>{codeTypeLabel}</InfoChip> : null}
          </div>
        </div>
      }
    >
      {licenseId ? (
        <PurchaseLicenseCodeSelector
          existingItems={existingItems}
          editingItem={editingItem}
          ownerLabel="license"
          onPick={onPick}
          onCancel={handleClose}
          oemNo={effectiveOemNo}
          isOemLicense={isOemLicense}
          codeType={0}
          scopeByOem
        />
      ) : null}
    </Modal>
  );
};

export default LicenseItemModal;
